"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconStyled = exports.modifiers = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var styled_components_modifiers_1 = require("styled-components-modifiers");

exports.modifiers = {
  small: function small() {
    return {
      styles: "\n      width: 1.25rem;\n      height: 1.25rem;\n    "
    };
  },
  xSmall: function xSmall() {
    return {
      styles: "\n      width: 0.875rem;\n      height: 0.875rem;\n    "
    };
  },
  rounded: function rounded() {
    return {
      styles: "\n      border-radius: 100%;\n    "
    };
  },
  white: function white(_ref) {
    var theme = _ref.theme;
    return {
      styles: "\n      svg, g, path {\n        fill: ".concat(theme.farmProject.gray_3, ";\n        stroke: ").concat(theme.farmProject.gray_3, ";\n      }\n    ")
    };
  },
  inverted: function inverted(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: "\n      svg, g, path {\n        fill: ".concat(theme.farmProject.light_gray, ";\n        stroke: ").concat(theme.farmProject.light_gray, ";\n      }\n    ")
    };
  },
  invertedStroke: function invertedStroke(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: "\n      * {\n        stroke: ".concat(theme.farmProject.light_gray, ";\n      }\n    ")
    };
  },
  invertedFill: function invertedFill(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: "\n      * {\n        fill: ".concat(theme.farmProject.light_gray, ";\n        polygon {\n          fill: ").concat(theme.farmProject.light_gray, ";\n        }\n      }\n    ")
    };
  },
  darkGrayColor: function darkGrayColor(_ref5) {
    var theme = _ref5.theme;
    return {
      styles: "\n      svg, g {\n        fill: ".concat(theme.farmProject.dark_gray, ";\n        stroke: ").concat(theme.farmProject.dark_gray, ";\n      }\n    ")
    };
  },
  darkGrayStroke: function darkGrayStroke(_ref6) {
    var theme = _ref6.theme;
    return {
      styles: "\n      svg, g, path {\n        stroke: ".concat(theme.farmProject.dark_gray, ";\n        fill: transparent;\n      }\n    ")
    };
  },
  brandColor: function brandColor(_ref7) {
    var theme = _ref7.theme;
    return {
      styles: "\n      svg, g, path {\n        fill: ".concat(theme.farmProject.green, ";\n      }\n    ")
    };
  },
  brandStroke: function brandStroke(_ref8) {
    var theme = _ref8.theme;
    return {
      styles: "\n      svg, g, path {\n        stroke: ".concat(theme.farmProject.brand_primary, ";\n        fill: transparent;\n      }\n    ")
    };
  },
  errorStroke: function errorStroke(_ref9) {
    var theme = _ref9.theme;
    return {
      styles: "\n      svg, g, path {\n        stroke: ".concat(theme.farmProject.error, ";\n        fill: transparent;\n      }\n    ")
    };
  },
  transparent: function transparent() {
    return {
      styles: "\n      svg {\n        path {\n          fill: transparent;\n        }\n      }\n    "
    };
  },
  rotate90: function rotate90() {
    return {
      styles: "\n    transform: rotate(90deg);\n    "
    };
  },
  rotate180: function rotate180() {
    return {
      styles: "\n    transform: rotate(180deg);\n    "
    };
  },
  rotate270: function rotate270() {
    return {
      styles: "\n    transform: rotate(270deg);\n    "
    };
  },
  roundedWhiteBg: function roundedWhiteBg(_ref10) {
    var theme = _ref10.theme;
    return {
      styles: "\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 2rem;\n      height: 2rem;\n      margin-left: auto;\n      border-radius: 1rem;\n      background-color: ".concat(theme.farmProject.white, ";\n      cursor: pointer;\n\n      svg {\n        max-width: 44%;\n        max-height: 44%;\n      }\n    ")
    };
  }
};
exports.IconStyled = styled_components_1.default.div.attrs({
  className: 'Icon'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 3.25rem;\n  height: 3.25rem;\n  line-height: 1;\n  background-color: transparent;\n  display: block;\n  overflow: hidden;\n  position: relative;\n  cursor: ", ";\n  ", "\n\n  svg {\n    width: 100%;\n    height: auto;\n    max-width: 100%;\n    height: auto;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n"])), function (_ref11) {
  var onClick = _ref11.onClick;
  return onClick ? 'pointer' : 'initial';
}, (0, styled_components_modifiers_1.applyStyleModifiers)(exports.modifiers));